// extracted by mini-css-extract-plugin
export default {"Emoji_Container":"Emoji_Container3bBKgOksRLfV"};